import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "user-section" }
const _hoisted_2 = {
  key: 0,
  class: "user-dropdown"
}
const _hoisted_3 = {
  key: 0,
  class: "user-email-secondary"
}
const _hoisted_4 = ["onClick"]
const _hoisted_5 = {
  key: 0,
  class: "menu-separator"
}

import { computed, ref } from "vue";
import { useRouter } from "vue-router";
import { useAuthStore } from "@/stores/auth";

interface MenuItem {
  id: string;
  label: string;
  action: () => void;
  class?: string;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'UserSection',
  props: {
    menuItems: {}
  },
  setup(__props: any) {



const authStore = useAuthStore();
const router = useRouter();

const currentUser = computed(() => authStore.user);
const currentProfileName = computed(() => authStore.currentProfileName);

// Menu state management
const isMenuOpen = ref(false);
const isHovered = ref(false);
const isFocused = ref(false);
const isMenuHovered = ref(false);

const shouldShowMenu = computed(
  () =>
    isMenuOpen.value ||
    isHovered.value ||
    isFocused.value ||
    isMenuHovered.value,
);

const toggleUserMenu = () => {
  isMenuOpen.value = !isMenuOpen.value;
};

const handleMouseEnter = () => {
  isHovered.value = true;
};

const handleMouseLeave = () => {
  isHovered.value = false;
};

const handleFocus = () => {
  isFocused.value = true;
};

const handleBlur = () => {
  isFocused.value = false;
  isMenuOpen.value = false;
};

const handleMenuMouseEnter = () => {
  isMenuHovered.value = true;
};

const handleMenuMouseLeave = () => {
  isMenuHovered.value = false;
};

const handleProfileSwitch = async () => {
  await router.push({ name: "profile-selection" });
  isMenuOpen.value = false;
};

const handleLogout = async () => {
  await authStore.logout();
  await router.push({ name: "login" });
  isMenuOpen.value = false;
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (currentUser.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("span", {
            class: "user-email",
            tabindex: "0",
            onClick: toggleUserMenu,
            onMouseenter: handleMouseEnter,
            onMouseleave: handleMouseLeave,
            onFocus: handleFocus,
            onBlur: handleBlur
          }, [
            _createTextVNode(_toDisplayString(currentProfileName.value) + " ", 1),
            (currentUser.value.email)
              ? (_openBlock(), _createElementBlock("span", _hoisted_3, "(" + _toDisplayString(currentUser.value.email) + ")", 1))
              : _createCommentVNode("", true),
            _cache[0] || (_cache[0] = _createElementVNode("span", { class: "dropdown-arrow" }, "▼", -1))
          ], 32),
          (shouldShowMenu.value)
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "user-menu",
                onMouseenter: handleMenuMouseEnter,
                onMouseleave: handleMenuMouseLeave
              }, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.menuItems, (item) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: item.id,
                    onClick: item.action,
                    class: _normalizeClass(["menu-item", item.class])
                  }, _toDisplayString(item.label), 11, _hoisted_4))
                }), 128)),
                (__props.menuItems && __props.menuItems.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_5))
                  : _createCommentVNode("", true),
                _createElementVNode("div", {
                  onClick: handleProfileSwitch,
                  class: "menu-item common"
                }, " Vaihda profiilia "),
                _createElementVNode("div", {
                  onClick: handleLogout,
                  class: "menu-item common"
                }, "Kirjaudu ulos")
              ], 32))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})